import React, { Component } from 'react';
import { Table, Button, Modal } from 'antd';
import { inject, observer } from 'mobx-react';
import { Link } from 'react-router-dom';

@inject('store')
@observer
export class StrategyTable extends Component {
    render() {
        let strategies = [];

        switch (this.props.type) {
            case 'buy_sell':
                strategies = this.props.store.strategyStore.buySell;
                break;
            case 'trigger':
                strategies = this.props.store.strategyStore.trigger;
                break;
            case 'adca':
                strategies = this.props.store.strategyStore.adca;
                break;
            case 'art':
                strategies = this.props.store.strategyStore.art;
                break;
            case 'signal':
                strategies = this.props.store.strategyStore.signal;
                break;
            default: //noop
        }

        return (
            <Table
                rowKey={'id'}
                dataSource={strategies}
                columns={[
                    {
                        title: 'Name',
                        dataIndex: 'name',
                        key: 'name',
                        sorter: (a, b) => {
                            if (a.name < b.name) return -1;
                            if (a.name > b.name) return 1;
                            return 0;
                        },
                        render: (text, o) => (
                            <Link to={`/a/strategies/standard/${o.id}`}>
                                {!text ? 'Untitled' : text}
                            </Link>
                        )
                    },
                    {
                        title: 'Used by bot',
                        dataIndex: 'used_by',
                        key: 'used_by',
                        render: (text, o) => {
                            const config = this.props.store.botStore.usedStrats[o.id];

                            if (!config) return null;
                            return <Link to={`/a/bot/${config.id}/positions`}>{config.name}</Link>;
                        }
                    },
                    {
                        title: 'Actions',
                        dataIndex: 'actions',
                        render: (text, o) => {
                            const configInUse = this.props.store.botStore.usedStrats[o.id] || false;

                            return (
                                <div>
                                    <Button
                                        type={'primary'}
                                        onClick={() => this.props.store.strategyStore.clone(o)}
                                    >
                                        Clone
                                    </Button>
                                    &nbsp;&nbsp;
                                    <Button
                                        disabled={configInUse}
                                        onClick={() => {
                                            Modal.confirm({
                                                title: 'Are you sure delete this strategy?',
                                                content: o.name,
                                                okText: 'Yes',
                                                okType: 'danger',
                                                cancelText: 'No',
                                                onOk: async () => {
                                                    await this.props.store.strategyStore.delete(
                                                        o.id
                                                    );
                                                },
                                                onCancel() {}
                                            });
                                        }}
                                        type={'danger'}
                                    >
                                        Delete
                                    </Button>
                                </div>
                            );
                        }
                    }
                ]}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/Strategies/Standard/Overview/StrategyTable.js